// const pattern = /^(?<origin>https?:\/\/[^\/]+)(?<pathname>[\?^]+)?(?<search>[\#^]+)?(?<hash>.*)$/;
// parse正则
const parsePattern = /^(https?:\/\/[^\/]+)([^\?]+)?([^\#]+)?(.*)$/;
// query正则
const queryPattern = /([^&]+)=([^&]+)/g;

// 获取query对象
function getQuery (search) {
  const query = {};
  for (var match = queryPattern.exec(search); match && match[0]; match = queryPattern.exec(search)) {
    if (match[1]) {
      query[match[1]] = match[2];
    }
  }
  return query;
}

export default function (url = decodeURIComponent(location.href)) {
  parsePattern.test(url);
  const urlParseResult = {
    origin: RegExp.$1,
    pathname: RegExp.$2,
    search: RegExp.$3,
    hash: RegExp.$4,
    query: null
  }
  urlParseResult.query = getQuery(urlParseResult.search.substr(1));
  return urlParseResult;
}


// WEBPACK FOOTER //
// ./src/library/urlParse.js